<template>
	<footer class="footer" :class="{ boxed }">
		<div class="wrap flex items-center justify-end gap-3">
			<div class="copy">
        <a href="https://www.ttpronet.com/" target="_blank" alt="TTProNet" rel="noopener noreferrer" class="mx-1">
				© Gardos Pronet SL. {{ year }} / #{{ buildDate }}
				</a>
			</div>
		</div>
	</footer>
</template>

<script lang="ts" setup>
import { computed, ref, toRefs } from "vue"
import Icon from "@/components/common/Icon.vue"
import BrainIcon from "@/assets/icons/brain-icon.svg"
import { useThemeStore } from "@/stores/theme"

const props = defineProps<{
	boxed: boolean
}>()
const { boxed } = toRefs(props)

const themeStore = useThemeStore()
const style = computed(() => themeStore.style)
const year = ref(new Date().getFullYear())
</script>

<script lang="ts">
export default {
  data() {
    return {
      buildDate: __BUILD_DATE__
    };
  },
};
</script>

<style lang="scss" scoped>
.footer {
	width: 100%;
	max-width: 100%;
	padding: var(--view-padding);
	padding-top: 0;
	overflow: hidden;
	font-size: 11px;

	.wrap {
		overflow: hidden;
		width: 100%;
		max-width: 100%;

		.copy {
			line-height: 1.6;
      color: #666;

			a {
				text-decoration: none;
			}
			* {
				display: inline;
			}
			i {
				display: inline-block;
			}
		}
	}

	&.boxed {
		padding: 0;
		.wrap {
			padding: 10px;
			max-width: var(--boxed-width);
			margin: 0 auto;
		}
	}

	@media (max-width: 700px) {
		font-size: 10px;

		i.n-icon {
			font-size: 18px !important;
		}
	}
}
</style>
